import React, { Fragment, useState, useContext, useEffect } from "react";
import { Menu, Transition, Dialog } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import SuggestedContractCard from "./ContractCard";
import { AppContext } from "../context/AppContext";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { saveAs } from "file-saver";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'js-cookie';

const Quiz = () => {
  const { t } = useTranslation();
  const {
    saveRecentQuizz,
    user,
    setRecentquizzToNull,
    questions,
    saveUser,
    siteKey,
  } = useContext(AppContext);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [open, setOpen] = useState(false);
  const [partnerEmail, setPartnerEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [captchaValue, setcaptchaValue] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [sentences, setSentences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recentQuiz, setrecentQuiz] = useState(
    Cookies.get("recentQuizz")
  );
  const [suggestionsScore, setSuggestionsScore] = useState({
    A: 0,
    B: 0,
  });
  const [suggestedContracts, setSuggestedContracts] = useState([
    {
      contract: "A",
      description: t(
        "This is the suggested contract description for contract A. Suggestion A description goes here."
      ),
      isSuggested: false,
    },
    {
      contract: "B",
      description: t(
        "This is the suggested contract description for contract B. Suggestion B description goes here."
      ),
      isSuggested: false,
    },
  ]);

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    const recentQuiz = Cookies.get("recentQuizz");
    setrecentQuiz(recentQuiz);
    if (recentQuiz) {
      const parsedQuizz = JSON.parse(recentQuiz);
      setAnswers(parsedQuizz.answers);
      setSuggestionsScore(parsedQuizz.suggestionsScore);
      setSentences(parsedQuizz.sentences || []);
      setSubmitted(true);

      const updatedSuggestedContracts = suggestedContracts.map((contract) => ({
        ...contract,
        isSuggested: contract.contract === parsedQuizz.result,
      }));

      setSuggestedContracts(updatedSuggestedContracts);
    }
  }, []);

  const handleAnswer = (questionId, answer) => {
    const question = questions.find((q) => q.id === questionId);

    if (
      question &&
      question.suggestionMapping &&
      question.suggestionMapping[answer]
    ) {
      const suggestion = question.suggestionMapping[answer].suggestion;
      setSuggestionsScore((prevScore) => ({
        ...prevScore,
        [suggestion]:
          prevScore[suggestion] + question.suggestionMapping[answer].score,
      }));
    }

    setAnswers({ ...answers, [questionId]: answer });
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const calculateProgress = () => {
    return (Object.keys(answers).length / questions.length) * 100;
  };

  const progressBarWidth = calculateProgress();

  const createAndDownloadPdf = async (data) => {
    const token = Cookies.get("token");
    const postheaders = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_ADDRESS}/quizes/pdf/create-pdf`,
        data,
        postheaders
      )
      .then(() =>
        axios.get(`${process.env.REACT_APP_ADDRESS}/quizes/pdf/fetch-pdf`, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      )
      .then((res) => {
        const pdfBlob = new Blob(
          [res.data],
          { type: "application/pdf" },
          postheaders
        );
        saveAs(pdfBlob, "generatedDocument.pdf");
      })
      .catch((error) => {
        console.error("Error creating or downloading PDF:", error);
      }).finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = async () => {
   
    await createAndDownloadPdf({ sentences, user });

  };

  const handleSubmit = async () => {
    let data = [];
    if (Object.keys(answers).length === questions.length) {
      let updatedSuggestionsScore = { ...suggestionsScore };

      Object.keys(answers).forEach((questionId) => {
        const question = questions.find((q) => q.id.toString() === questionId);
        const answer = answers[questionId];

        if (question && question.suggestionMapping) {
          const suggestion = question.suggestionMapping[answer];
          if (suggestion) {
            updatedSuggestionsScore[suggestion.suggestion] += suggestion.score;
          }
        }

        if (question && question.SentenceMapping) {
          const sentence = question.SentenceMapping[answer];

          if (sentence) {
            data.push(sentence);
          }
        }
      });
      setSentences(data);

      let result = "";
      let maxScore = 0;

      Object.keys(updatedSuggestionsScore).forEach((suggestion) => {
        if (updatedSuggestionsScore[suggestion] > maxScore) {
          maxScore = updatedSuggestionsScore[suggestion];
          result = suggestion;
        }
      });

      alert(t(`Your recommended contract is: Contract ${result}`));

      setSuggestedContracts((prevContracts) => {
        const updatedContracts = Object.keys(updatedSuggestionsScore)
          .filter((suggestion) =>
            prevContracts.some((contract) => contract.contract === suggestion)
          )
          .map((suggestion) => ({
            contract: suggestion,
            description: t("Your suggested contract description goes here."),
            isSuggested: suggestion === result,
          }));

        return updatedContracts;
      });

      setSubmitted(true);

      saveRecentQuizz({
        answers,
        suggestionsScore: updatedSuggestionsScore,
        result,
        sentences: data,
        Paid: false,
      });

      const saved = saveQuiz({
        answers,
        suggestionsScore: updatedSuggestionsScore,
        result,
        sentences: data,
      });

      console.log("quiz saved: ", saved);
    } else {
      alert(t("Please answer all questions before submitting."));
    }
  };

  const isQuizCompleted = Object.keys(answers).length === questions.length;

  const handleBack = () => {
    setCurrentQuestion(currentQuestion - 1);
  };

  const saveQuiz = async (object) => {
    try {
      const token = Cookies.get("token");

      if (!user._id || !object) {
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/quizes/${user._id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(object),
        }
      );

      if (response.status === 200) {
        return true;
      } else if (response.status === 404) {
        return false;
      } else if (response.status === 400) {
        return false;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const InvitePartner = async (e) => {
    e.preventDefault();

    try {
      const token = Cookies.get("token");
      if (partnerEmail === user.email) {
        setErrorMessage(
          "You can't enter your email, please ensure it's your partner's email."
        );
        return;
      }

      if (!partnerEmail || !user._id) {
        setErrorMessage("Email address is required.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/users/invitePartner/${partnerEmail}/${user._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setErrorMessage("");
        setOpen(false);

        // Fetch user data after successful invitation
        const userResponse = await fetch(
          `${process.env.REACT_APP_ADDRESS}/users/getOne/${user._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (userResponse.ok) {
          const userData = await userResponse.json();
          saveUser(userData);
        } else {
          setErrorMessage("Failed to fetch user data.");
        }
      } else if (response.status === 404) {
        setErrorMessage("Email not found.");
      } else if (response.status === 400) {
        setErrorMessage("Bad request, please refresh the page.");
      } else {
        setErrorMessage("Internal server error.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred.");
    }
  };

  const renderQuestion = () => {
    const currentQuestionData = questions[currentQuestion];

    switch (currentQuestionData.questionType) {
      case "radio":
        return (
          <div className="space-y-4">
            {currentQuestionData.choices.map((choice, index) => (
              <label
                key={index}
                className="block bg-white hover:bg-purple-100 rounded-lg shadow-md p-4 transition-all duration-300 ease-in-out transform hover:scale-95 text-black"
              >
                <input
                  type="radio"
                  name={`question_${currentQuestionData.id}`}
                  value={choice}
                  onChange={() => handleAnswer(currentQuestionData.id, choice)}
                  checked={answers[currentQuestionData.id] === choice}
                  className="appearance-none border rounded-full w-6 h-6 checked:bg-pink-400 checked:border-pink-600 focus:ring-0 hover:bg-transparent"
                />

                <span
                  className={`ml-2 ${
                    answers[currentQuestionData.id] === choice
                      ? "text-black"
                      : ""
                  }`}
                >
                  {choice}
                </span>
              </label>
            ))}
          </div>
        );

      case "checkbox":
        return (
          <div className="space-y-4">
            {currentQuestionData.choices.map((choice, index) => (
              <label
                key={index}
                className="block bg-white hover:bg-purple-100 rounded-lg shadow-md p-4 transition-all duration-300 ease-in-out transform hover:scale-95 text-black"
              >
                <input
                  type="checkbox"
                  name={`question_${currentQuestionData.id}`}
                  value={choice}
                  onChange={() => handleAnswer(currentQuestionData.id, choice)}
                  checked={
                    answers[currentQuestionData.id] &&
                    answers[currentQuestionData.id].includes(choice)
                  }
                  className="appearance-none border rounded-full w-6 h-6 checked:bg-pink-400 checked:border-pink-600 focus:ring-0 hover:bg-transparent"
                />

                <span
                  className={`ml-2 ${
                    answers[currentQuestionData.id] &&
                    answers[currentQuestionData.id].includes(choice)
                      ? "text-black"
                      : ""
                  }`}
                >
                  {choice}
                </span>
              </label>
            ))}
          </div>
        );

      case "text":
        return (
          <textarea
            className="w-full p-3 border rounded-md"
            placeholder={t("Type your answer here...")}
            value={answers[currentQuestionData.id] || ""}
            onChange={(e) =>
              handleAnswer(currentQuestionData.id, e.target.value)
            }
          />
        );

      case "dropdownCounty":
        return (
          <div className="relative inline-block text-left w-full max-w-md mx-auto z-30">
            <Menu as="div" className="relative">
              <div>
                <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                  {answers[currentQuestionData.id] || t("Country")}
                  <ChevronDownIcon
                    className="-mr-1 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 mt-2 w-full max-h-40 overflow-y-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {currentQuestionData.choices.map((choice, index) => (
                      <Menu.Item key={index}>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "block px-4 py-2 text-sm"
                            )}
                            onClick={() =>
                              handleAnswer(currentQuestionData.id, choice)
                            }
                          >
                            {choice}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-r bg-white text-black">
      <div className="flex justify-between items-start ml-24">
        <Link to="/" className="flex items-start">
          <img className="h-auto w-28" src={logo} alt="logo" />
        </Link>
        <div className="mt-10 mr-8">
          <button
            className="inline-flex justify-center px-2 py-2 text-sm font-medium
           text-white bg-[#F25668] border border-transparent rounded-md shadow-sm 
            hover:bg-[#EF6575] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
            onClick={() => {
              setOpen(true);
            }}
          >
            Invite your partner
          </button>

          {recentQuiz !== null && (
            <button
              className="inline-flex justify-center px-2 py-2 mx-4 text-sm font-medium
           text-white bg-[#F25668] border border-transparent rounded-md shadow-sm 
            hover:bg-[#EF6575] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
              onClick={() => {
                Cookies.remove("recentQuizz");
                setRecentquizzToNull();
                window.location.reload();
              }}
            >
              Retake Quiz
            </button>
          )}
        </div>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-y-auto z-40"
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="fixed inset-0 flex items-center justify-center">
              <div className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg w-full">
                <div className="px-6 py-4">
                  <div className="text-center">
                    <div className="flex justify-center">
                      <img className="h-auto w-28" src={logo} alt="logo" />
                    </div>

                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      Invite your partner.
                    </Dialog.Title>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                      <p>
                        Invite your partner to receive your quiz results and
                        proceed with the quiz.
                      </p>
                    </div>
                  </div>

                  <form className="mt-5">
                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="mt-1 block w-full shadow-sm sm:text-sm focus:ring-[#EF6575] focus:border-[#EF6575] border-gray-300 rounded-md"
                        placeholder="you@example.com"
                        value={partnerEmail}
                        onChange={(e) => setPartnerEmail(e.target.value)}
                      />
                    </div>

                    <div className="flex justify-end">
                      <button
                        type="button"
                        className="mr-2 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-[#F25668] border border-transparent rounded-md shadow-sm hover:bg-[#EF6575] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
                        onClick={InvitePartner}
                      >
                        Invite
                      </button>
                    </div>
                  </form>
                  {errorMessage && (
                    <div className="rounded-md bg-red-50 p-4 mt-6">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <svg
                            className="h-5 w-5 text-red-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-red-800">
                            {errorMessage}
                          </h3>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>

      <div className="flex-grow w-full p-8 rounded-lg shadow-lg mx-auto overflow-hidden">
        {submitted ? (
          <>
            <div className="flex flex-col items-center justify-center">
              <h2 className="text-center text-4xl font-bold mb-8">
                Get your contract here
              </h2>
              {loading ? (
                <div role="status" className="flex justify-center mt-12">
                  <svg
                    aria-hidden="true"
                    className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <button
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-[#F25668] border border-transparent rounded-md shadow-sm hover:bg-[#EF6575] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-pink-500"
                  onClick={handleDownload}
                >
                  Download your Contract
                </button>
              )}
            </div>
            <div className="flex flex-wrap justify-center items-center mt-6 space-x-4">
              {suggestedContracts.map((contract, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center space-y-2"
                >
                  <SuggestedContractCard
                    contract={contract.contract}
                    description={contract.description}
                    isSuggested={contract.isSuggested}
                  />
                </div>
              ))}
            </div>

            <div className="flex flex-wrap justify-center items-center mt-10 space-x-4">
              {suggestedContracts.map((contract, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center space-y-2"
                >
                  {contract.isSuggested && (
                    <div className="text-center ">
                      <p className="font-bold text-2xl my-6">{`Contract ${contract.contract}`}</p>
                      <p className="text-xl">{contract.description}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <h1 className="text-4xl font-bold mb-4">
              {t("Marriage Prenup Quiz")}
            </h1>

            <p className="text-lg mb-4">
              {t(
                "This quiz will help you determine which is the best contract for you and your partner."
              )}
            </p>

            <div className="mb-6">
              <div className="relative pt-1">
                <div className="flex mb-2 items-center justify-between">
                  <div className="text-right">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full bg-purple-200">
                      {Object.keys(answers).length} of {questions.length}
                    </span>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="text-xs leading-none">
                    <div className="font-semibold text-sm">
                      {isQuizCompleted
                        ? t("Quiz Completed")
                        : `Question ${currentQuestion + 1}`}
                    </div>

                    <div className="text-sm">
                      {isQuizCompleted
                        ? t("Submit your answers")
                        : t("Answer the following question")}
                    </div>
                  </div>

                  {!isQuizCompleted && (
                    <div className="text-2xl font-bold text-purple-700">
                      {`${Math.round(progressBarWidth)}%`}
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full h-2 bg-purple-200 mt-2 rounded-full relative overflow-hidden">
                <div
                  className="absolute h-full bg-purple-400 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${progressBarWidth}%` }}
                ></div>
              </div>
            </div>

            <form>
              <p className="text-lg font-semibold mb-4">
                {questions[currentQuestion].text}
              </p>

              {renderQuestion()}

              <div className="mt-6 flex justify-between">
                {currentQuestion > 0 && (
                  <button
                    type="button"
                    className="bg-purple-500 text-white py-2 px-4 rounded transition-all duration-300 ease-in-out hover:bg-purple-600"
                    onClick={handleBack}
                  >
                    {t("Back")}
                  </button>
                )}

                {isQuizCompleted ? (
                  <>
                    <button
                      disabled={!captchaValue}
                      type="button"
                      className="bg-purple-500 text-white py-2 px-4 rounded transition-all duration-300 ease-in-out hover:bg-purple-600"
                      onClick={handleSubmit}
                    >
                      {t("Submit")}
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className={`bg-purple-500 text-white py-2 px-4 rounded transition-all duration-300 ease-in-out hover:bg-purple-600 ${
                      Object.keys(answers).length >= currentQuestion + 1
                        ? ""
                        : "opacity-50 cursor-not-allowed"
                    }`}
                    onClick={() => setCurrentQuestion(currentQuestion + 1)}
                    disabled={Object.keys(answers).length < currentQuestion + 1}
                  >
                    {t("Next")}
                  </button>
                )}
              </div>
              <div className="mt-4 flex justify-end">
                <ReCAPTCHA
                  sitekey={siteKey}
                  onChange={(val) => setcaptchaValue(val)}
                />
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default Quiz;
